/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react'
import { Tabs, Tab } from 'react-bootstrap'
import InfiniteScroll from 'react-infinite-scroll-component'
import FeatherIcon from 'feather-icons-react'
import notification_user from '../../assets/img/notification_popup_user.png'
import { useDispatch, useSelector } from 'react-redux'
import { SpinnerContext } from '../../context/spinnerContext'
import {
  deleteNotification,
  getCheckinCheckoutNotification,
  getCleanersRegisterNotifications,
  getClientRegisterNotification,
  getRejectedCleaningNotification
} from '../../redux/slices/notificationSlice'
import DeletePopup from '../deletePopup'
import { formatTimeAgo } from '../../helper/function'
import { Link } from 'react-router-dom'

const NotificationSection = () => {
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)
  const { rejectedCleaningNotification, checkinCheckoutNotification, clientCreateNotification, cleanerCreateNotification } = useSelector(
    ({ notification }) => notification
  )

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [isRefresh, setIsRefresh] = useState(true)
  const [currentTab, setCurrentTab] = useState('tabs1')
  const [currentPage, setCurrentPage] = useState(1)
  const [hasMore, setHasMore] = useState(true)
  const [notifications, setNotifications] = useState([])
  const [notificationID, setNotificationID] = useState(null)

  const itemsPerPage = 10

  const openDeleteModal = (_id) => {
    setNotificationID(_id)
    setIsDeleteModalOpen(!isDeleteModalOpen)
  }

  const confirmDelete = () => {
    if (!notificationID) return
    changeLoader(true)
    dispatch(deleteNotification(notificationID))
      .then((response) => {
        if (response?.payload?.status === 200) {
          setCurrentPage(1)
          setIsRefresh(true)
          setNotifications([])
        }
      })
      .finally(() => {
        changeLoader(false)
        setIsDeleteModalOpen(false)
      })
  }

  const fetchNotifications = () => {
    const params = { page: currentPage, limit: itemsPerPage, isPagination: true }
    changeLoader(true)
    const notificationAPIs = {
      tabs1: getCheckinCheckoutNotification,
      tabs2: getRejectedCleaningNotification,
      tabs3: getClientRegisterNotification,
      tabs4: getCleanersRegisterNotifications
    }

    const fetchNotificationAPI = notificationAPIs[currentTab] || getCleanersRegisterNotifications

    dispatch(fetchNotificationAPI(params))
      .then((response) => {
        const notificationData = response?.payload?.data?.data?.notifications || []
        setNotifications((prev) => [...prev, ...notificationData])
        setHasMore(notificationData.length >= itemsPerPage)
        setIsRefresh(false)
      })
      .finally(() => {
        changeLoader(false)
        setIsRefresh(false)
      })
  }

  useEffect(() => {
    setNotifications([])
    setCurrentPage(1)
    setHasMore(true)
  }, [currentTab])

  useEffect(() => {
    if (!isRefresh) {
      return
    }
    fetchNotifications()
  }, [currentPage, currentTab, isRefresh])

  const loadMoreNotifications = () => {
    setCurrentPage((prevPage) => prevPage + 1)
    setIsRefresh(true)
  }

  const handleTabChange = (key) => {
    setCurrentPage(1)
    setCurrentTab(key)
    setIsRefresh(true)
    setHasMore(true)
  }

  return (
    <div className="col-md-12 col-lg-12 col-xl-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="cleanings_month_text fw-bold mb-0">Notification</h4>
        <button className="btn btn-primary btn-small" style={{ visibility: 'hidden' }}>
          See More
        </button>
      </div>

      <div className="notification_sec_main mb-3"></div>

      <div className="common_card_div mb-4">
        <div className="common_tabs_main_div">
          <Tabs defaultActiveKey="tabs1" id="uncontrolled-tab-example" onSelect={handleTabChange}>
            <Tab eventKey="tabs1" title="Checkins & Checkouts">
              <NotificationList
                notifications={notifications}
                hasMore={hasMore}
                loadMore={loadMoreNotifications}
                scrollableTargetId="notification-tab1-scrollable-div"
                openDeleteModal={openDeleteModal}
                totalRecords={checkinCheckoutNotification?.totalRecords}
              />
            </Tab>
            <Tab eventKey="tabs2" title="Rejected By Cleaning Team">
              <NotificationList
                notifications={notifications}
                hasMore={hasMore}
                loadMore={loadMoreNotifications}
                scrollableTargetId="notification-tab2-scrollable-div"
                openDeleteModal={openDeleteModal}
                totalRecords={rejectedCleaningNotification?.totalRecords}
              />
            </Tab>
            <Tab eventKey="tabs3" title="New Client Notification">
              <NotificationList
                notifications={notifications}
                hasMore={hasMore}
                loadMore={loadMoreNotifications}
                scrollableTargetId="notification-tab3-scrollable-div"
                openDeleteModal={openDeleteModal}
                totalRecords={clientCreateNotification?.totalRecords}
              />
            </Tab>
            <Tab eventKey="tabs4" title="New Cleaner Notification">
              <NotificationList
                notifications={notifications}
                hasMore={hasMore}
                loadMore={loadMoreNotifications}
                scrollableTargetId="notification-tab4-scrollable-div"
                openDeleteModal={openDeleteModal}
                totalRecords={cleanerCreateNotification?.totalRecords}
              />
            </Tab>
          </Tabs>
        </div>
      </div>

      {isDeleteModalOpen && (
        <DeletePopup isDeleteModalOpen={isDeleteModalOpen} toggle={openDeleteModal}>
          <div className="multi_btn_div">
            <button type="button" className="btn common-outline-btn w-100" onClick={() => setIsDeleteModalOpen(false)}>
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger common-field-btn w-100"
              onClick={(event) => {
                event.stopPropagation()
                confirmDelete()
              }}
            >
              Delete
            </button>
          </div>
        </DeletePopup>
      )}
    </div>
  )
}

const NotificationList = ({ notifications, hasMore, loadMore, scrollableTargetId, openDeleteModal, totalRecords }) => (
  <div id={scrollableTargetId} className="notification_list_main_div">
    <InfiniteScroll
      dataLength={notifications?.length}
      next={totalRecords > notifications?.length && loadMore}
      hasMore={hasMore}
      scrollableTarget={scrollableTargetId}
    >
      {notifications?.length > 0 ? (
        notifications.map((notification, index) => <NotificationCard key={index} notification={notification} openDeleteModal={openDeleteModal} />)
      ) : (
        <p className="text-center">No Notification</p>
      )}
    </InfiniteScroll>
  </div>
)

const NotificationCard = ({ notification, openDeleteModal }) => {
  const { userImage, subject: userName, body: userInfo, created_at: time, notification_id } = notification

  return (
    <div className="notification_card_sec">
      <div className="notification_card_personal_info">
        <img className="notification_user_img" src={notification_user || userImage} alt="notification_user" />
        <div className="notification_card_text">
          <h4 className="notification_user_name">{userName}</h4>
          <p className="notification_user_info">{userInfo}</p>
          <h6 className="notification_time">{formatTimeAgo(time)}</h6>
        </div>
      </div>
      <div className="notification_card_timimng_info">
        <Link
          className="btn-action-icon delete_icon_div border-5"
          style={{ borderRadius: '50%' }}
          onClick={(event) => {
            event.stopPropagation()
            openDeleteModal(notification_id)
          }}
        >
          <FeatherIcon icon="trash-2" color="red" />
        </Link>
      </div>
    </div>
  )
}

export default NotificationSection
